import WidgetFileLoader from 'components/Widgets/WidgetFileLoader';
import useAlert from 'hooks/useAlert';
import { toJS } from 'mobx';

const FileTypeField = ({
  selectItem,
  setNewSelectItem,
  setFiles,
  isUserFieldsOperation,
  item,
  disabled,
}) => {
  const { showAlert } = useAlert();

  const sureDeleteFileAlert = (callback) =>
    showAlert('Вы действительно хотите удалить файл?', 'sure', callback);

  return (
    <WidgetFileLoader
      onLoadFile={(files) => {
        const setting = toJS(selectItem?.setting);
        setNewSelectItem({
          value: '',
          setting,
          files: toJS(files),
        });
        setFiles(files);
      }}
      onDeleteOldFile={(index) => {
        sureDeleteFileAlert(() => {
          let settings = [...selectItem?.setting];
          if (settings.length) settings.splice(index, 1);

          setNewSelectItem({
            ...selectItem,
            value: '',
            setting: settings,
          });
        });
      }}
      oldFiles={isUserFieldsOperation ? selectItem?.setting : []}
      listFile={selectItem?.files || []}
      title="Перетащите файл сюда или выберите файл"
      subtitle={`Максимальный размер файла ${item?.setting?.max_size}Мб (поддерживаемые форматы ${item?.setting?.type?.join(', ')})`}
      disabled={disabled}
    />
  );
};

export default FileTypeField;
